import { render } from "./VIcon.vue?vue&type=template&id=179d7b1c&scoped=true"
import script from "./VIcon.vue?vue&type=script&lang=js"
export * from "./VIcon.vue?vue&type=script&lang=js"

import "./VIcon.vue?vue&type=style&index=0&id=179d7b1c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179d7b1c"]])

export default __exports__